import { createContext, useContext } from 'react';
import { IUseDropdownContext } from './types';

export const DropdownContext = createContext<IUseDropdownContext>({} as IUseDropdownContext);

const useDropdownContext = () => {
    const context = useContext(DropdownContext);

    if (!context) {
        throw new Error('Dropdown compound components cannot be rendered outside the Dropdown component');
    }

    return context;
};

export default useDropdownContext;
